import { useModal } from "@commonlibs";
import { useState } from "react";
import QrScannerModal from "ui/common/components/feedback/QrScannerModal/QrScannerModal";
import { useAddressExists } from "features/wallet/hooks/useAddressExists";
import { UseUserAddressTextFieldReturn } from "../UserAddressTextField.types";
import { useTranslate } from "ui/locale";
import useQrScanNavigation from "ui/transactions/containers/PayModal/utils/useQrScanNavigation";

export default function useUserAddressTextField(defaultValue: string): UseUserAddressTextFieldReturn {
    const { showModal } = useModal();
    const translate = useTranslate();
    const [scanned, setScanned] = useState<string>(defaultValue);
    const [addressOrEmail, setAddressOrEmail] = useState<string>(defaultValue);
    const { isFetching, data: exist } = useAddressExists(addressOrEmail);
    const isError = !isFetching && !exist;

    const { navigateToTransactionTab } = useQrScanNavigation();

    const error: [boolean, string] = [isError, translate("destinationAccountDoesNotExist", { ns: "error" })];

    function handleOnScan(qrValue: string) {
        const address = getWalletAddress(qrValue);
        setScanned(address);
        setAddressOrEmail(address);
        navigateToTransactionTab(qrValue);
    }

    function getWalletAddress(qrValue: string) {
        try {
            const parsedQr: Record<string, string> = JSON.parse(qrValue);
            return parsedQr.address || parsedQr.destinationAddress;
        } catch (error) {
            const value = qrValue.includes("=") ? qrValue.split("=")[1] : qrValue;
            return value;
        }
    }

    function handleCameraClick() {
        showModal(QrScannerModal, { onScan: handleOnScan });
    }

    return {
        getWalletAddress,
        handleOnScan,
        searchBarProps: {
            placeholder: translate("introduceRecipient"),
            onChange: setAddressOrEmail,
            defaultValue: addressOrEmail,
            error,
            loadingHint: true,
            loadingPrefix: false,
            loading: isFetching,
            showValid: !isFetching,
            validElement: false,
            errorElement: false,
        },
        scanned,
        handleCameraClick,
    };
}
